// WAI-ARIA APG tabs with automatic activation, rendered by snippets/product-info-tabs.liquid.
(function () {
  if (customElements.get('product-info-tabs')) return;

  class ProductInfoTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tablist"] [role="tab"]'));
      this.abortController = new AbortController();
      const { signal } = this.abortController;

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.select(tab), { signal });
        tab.addEventListener('keydown', (event) => this.onKeydown(event), { signal });
      });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    onKeydown(event) {
      if (event.altKey || event.ctrlKey || event.metaKey) return;

      const index = this.tabs.indexOf(event.currentTarget);
      const last = this.tabs.length - 1;
      let next;

      switch (event.key) {
        case 'ArrowRight':
          next = index === last ? 0 : index + 1;
          break;
        case 'ArrowLeft':
          next = index === 0 ? last : index - 1;
          break;
        case 'Home':
          next = 0;
          break;
        case 'End':
          next = last;
          break;
        default:
          return;
      }

      event.preventDefault();
      this.select(this.tabs[next]);
      this.tabs[next].focus();
    }

    select(selectedTab) {
      this.tabs.forEach((tab) => {
        const isSelected = tab === selectedTab;
        tab.setAttribute('aria-selected', String(isSelected));
        tab.tabIndex = isSelected ? 0 : -1;

        const panel = this.querySelector(`#${CSS.escape(tab.getAttribute('aria-controls'))}`);
        if (panel) panel.hidden = !isSelected;
      });
    }
  }

  customElements.define('product-info-tabs', ProductInfoTabs);
})();
